// https://github.com/moment/moment/issues/3650
export default function interopDefault(m) {
    return m["default"] || m;
}


//////////////////
// WEBPACK FOOTER
// /Users/jim/Documents/GitHub/chenshuai/ant-design-pro-site/scaffold/node_modules/antd/es/_util/interopDefault.js
// module id = null
// module chunks = 